<template>
    <div class="singin">
        <div class="singin-main">
            <div class="singin-logo"></div>
            <div class="singin-text">
                惺灵 Singin​ 是一款基于网络服务训练的智能大模型，专注于协议与端口分析，能够精准识别内网服务，为企业网络安全、运维管理及渗透测试提供高效、精准的技术支持。
            </div>

            <div class="singin-items">
                <div class="singin-item">
                    <div class="item-text1">
                        协议智能解析
                    </div>
                    <div class="item-text2">
                        深度分析 TCP/IP、UDP、HTTP、HTTPS 等网络协议，识别异常通信行为
                    </div>
                    <div class="item-icon item-icon1"></div>
                </div>
                <div class="singin-item">
                    <div class="item-text1">
                        端口精准识别
                    </div>
                    <div class="item-text2">
                        基于端口扫描数据，自动匹配服务类型（如 80=HTTP、443=HTTPS、3306=MySQL）
                    </div>
                    <div class="item-icon item-icon2"></div>
                </div>
                <div class="singin-item singin-item-last">
                    <div class="item-text1">
                        内网服务探测
                    </div>
                    <div class="item-text2">
                        扫描内网开放端口，识别隐藏服务（如数据库、SSH、RDP），并评估安全风险
                    </div>
                    <div class="item-icon item-icon3"></div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "singin"
    }
</script>

<style lang="less">

    .singin{
        position: fixed;
        top: 0;
        z-index: 1000;
        height: 100%;
        width: 100%;
        background-image: url("../assets/singin/bg.png");
        background-size: cover;
        background-repeat: no-repeat;

        .singin-main{
            margin: 0 auto;
            overflow: hidden;
            width: 1400px;
            .singin-logo{
                margin-top: 3%;
                width: 242px;
                height: 168px;
                background-image: url("../assets/singin/singin.svg");
                background-size: 100%;
                background-repeat: no-repeat;
            }

            .singin-text{
                margin-top: 35px;
                font-size: 24px;
                font-weight: 500;
                line-height: 36px;
                color: #fff;
                width: 630px;
            }
            .singin-items{
                margin-top: 58px;
                .singin-item{
                    display: inline-block;
                    position: relative;
                    margin-right: 25px;
                    padding: 28px 33px;
                    box-sizing: border-box;
                    width: 450px;
                    height: 450px;
                    border-radius: 20px;
                    backdrop-filter: blur(80px);
                    background: rgba(255, 255, 255, 0.1);
                    .item-text1{
                        font-size: 30px;
                        font-weight: 700;
                        line-height: 45px;
                        color: #ffffff;
                    }
                    .item-text2{
                        margin-top: 16px;
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 36px;
                        color: #ffffff;
                    }
                    .item-icon{
                        position: absolute;
                        bottom: 36px;
                        left: 50%;
                        transform: translate(-50%,0);
                    }
                    .item-icon1{
                        width: 216px;
                        height: 180px;
                        background-image: url("../assets/singin/s1.png");
                        background-size: 100%;
                        background-repeat: no-repeat;
                    }
                    .item-icon2{
                        width: 180px;
                        height: 180px;
                        background-image: url("../assets/singin/s2.png");
                        background-size: 100%;
                        background-repeat: no-repeat;
                    }
                    .item-icon3{
                        width: 224px;
                        height: 180px;
                        background-image: url("../assets/singin/s3.png");
                        background-size: 100%;
                        background-repeat: no-repeat;
                    }
                }
                .singin-item-last{
                    margin-right: 0 !important;
                }

            }
        }

    }

</style>